import { createServerFn } from '@tanstack/react-start'
import { env } from 'cloudflare:workers'
import { getDb } from '../db/client'
import { type Profile, getProfile } from '../db/queries'
import { isValidHandle } from '../lib/handle'

export const getProfileFn = createServerFn({ method: 'GET' })
  .inputValidator((handle: string) => handle)
  .handler(async ({ data: handle }): Promise<Profile | null> => {
    if (!isValidHandle(handle)) return null
    return getProfile(getDb(env.DB), handle, Date.now())
  })
